export default __webpack_public_path__ + "static/media/logo-for-light.462c70d7.png";